import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { P1Regular as P1RegularStyle } from 'theme/typography';

interface P1RegularProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the P1Regular typography style.
 */
const P1Regular: React.FC<P1RegularProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...P1RegularStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default P1Regular;
